// extracted by mini-css-extract-plugin
export default {"aboutSection":"AboutUs_aboutSection__juQRg","redText":"AboutUs_redText__kz5bl"};